/*@ngInject*/
const UserProfileRepository = function ($q, baseRepository) {

    angular.extend(this, baseRepository);

    this.loadUserById = function (id, submissionId, notificationId, chatMessageId, emailMessageId) {
        const url = `/rest/User/${id}`,
            config = {
                params: {
                    registrationIdentifier: `/User/${id}`,
                    submissionId: submissionId,
                    notificationId: notificationId,
                    chatMessageId: chatMessageId,
                    emailMessageId: emailMessageId
                }
            }
        return this.get(url, config);
    };

};

angular.module('umCore')
    .service('userProfileRepository', UserProfileRepository);
